import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { faBolt, faDrawPolygon } from '@fortawesome/free-solid-svg-icons';
import { AbstractSecondaryToolbar } from '../../../../cross-team-shared/annotation/shared/toolbars/secondary-toolbar/abstract-secondary-toolbar';
import { ToggleButton } from '../../../../cross-team-shared/components/toggle-button-group/toggle-button-group.component';
import { AbstractSensorContentState2D } from '../../state/abstract-sensor-content-state-2d';
import { AbstractSensorContentStore2D } from '../../state/abstract-sensor-content-store-2d';
import { PolygonTool } from './polygon-tool';

@Component({
  selector: 'h3-polygon-secondary-toolbar',
  templateUrl: './polygon-secondary-toolbar.component.html',
  styleUrls: ['./polygon-secondary-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PolygonSecondaryToolbarComponent
  extends AbstractSecondaryToolbar<
    AbstractSensorContentState2D,
    AbstractSensorContentStore2D,
    PolygonTool
  >
  implements AfterViewInit
{
  @ViewChild('clickxIcon', { read: TemplateRef })
  private clickxIcon!: TemplateRef<unknown>;

  buttons!: ToggleButton[];
  faDrawPolygon = faDrawPolygon;
  faBolt = faBolt;

  ngAfterViewInit() {
    this.buttons = [
      { value: 'manual', icon: faDrawPolygon },
      { value: 'clickx', template: this.clickxIcon },
    ];
  }
}
